var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.004,
    height: 22.004,
    viewBox: "0 0 22.004 22.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2697",
    "data-name": "Group 2697",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    d: "M9.674-.85A10.524,10.524,0,1,1-.85,9.674,10.536,10.536,0,0,1,9.674-.85Zm0,19.026a8.5,8.5,0,1,0-8.5-8.5A8.512,8.512,0,0,0,9.674,18.176Z",
    transform: "translate(0.85 0.85)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M20.562,21.572a1.008,1.008,0,0,1-.715-.3L16.1,17.525A1.011,1.011,0,0,1,17.525,16.1l3.751,3.751a1.011,1.011,0,0,1-.715,1.725Z",
    transform: "translate(0.432 0.432)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.5770ad411fa1ea3739cf7129a03c76cd.svg";
export { ForwardRef as ReactComponent };